// extracted by mini-css-extract-plugin
export var container = "_40-0";